import { makeStyles } from '@material-ui/core/styles';
import resourcesFormStyles from '../../ResourcesForm/styles';

export default makeStyles(resourcesFormStyles);
